import axios, { BASE_URL } from "../axios";
import BaseModel from "./baseModel";

export default class CocModel extends BaseModel {
  static endPoint = "cocs/";

  static get(params = {}) {
    return axios.get(BASE_URL + this.endPoint + "v2", { params });
  }

  static postToSlims(cocId) {
    return axios.get(BASE_URL + this.endPoint + "post-to-slims/" + cocId);
  }

  static getUnSeenByUser() {
    return axios.get(BASE_URL + this.endPoint + "get-unseen-count/");
  }

  static markAsSeen(cocId) {
    return axios.put(BASE_URL + this.endPoint + "mark-as-seen/" + cocId);
  }
}
